













module.exports =
  methods:

    goNext: ->
        $('html, body').animate({ scrollTop: $('.marquee').outerHeight() + 20}, 700)




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home/next-block.vue